'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DAY_SPLITTER = exports.DAY_SPLITTER = '---daySplitter';
var WEEK_SPLITTER = exports.WEEK_SPLITTER = '---WeekSplitter';

var AM = exports.AM = 'AM';
var PM = exports.PM = 'PM';
var DAYS_IN_WEEK = exports.DAYS_IN_WEEK = 7;

var DECEMBER_MONTH_INDEX = exports.DECEMBER_MONTH_INDEX = 11;

var DAYS_CALENDAR = exports.DAYS_CALENDAR = 'DAYS_CALENDAR';
var MONTHS_CALENDAR = exports.MONTHS_CALENDAR = 'MONTHS_CALENDAR';
var YEARS_CALENDAR = exports.YEARS_CALENDAR = 'YEARS_CALENDAR';

var ABBREVIATED_DAYS = exports.ABBREVIATED_DAYS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
var ABBREVIATED_MONTHS = exports.ABBREVIATED_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var FULL_MONTHS_NAMES = exports.FULL_MONTHS_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// April 22, 1996 - US, Bhutan, Canada, China, Korea, Taiwan, Hungary, Iran, Japan, Lithuania, Mongolia
var monthDayYearDateFormatLocales = exports.monthDayYearDateFormatLocales = ['en', 'en-US', 'en-US-POSIX', 'dz', 'dz-BT', 'en-CA', 'zh', 'zh-Hans', 'zh-Hans-CN', 'zh-Hans-HK', 'zh-Hans-MO', 'zh-Hans-SG', 'zh-Hant', 'zh-Hant-HK', 'zh-Hant-MO', 'zh-Hant-TW', 'ko', 'ko-KR', 'ta', 'ta-IN', 'ta-LK', 'hu', 'hu-HU', 'fa_IR', 'ja', 'ja-JP', 'lt_LT', 'mn', 'mn-MN'];

var sundayAsFirstDayOfWeekLocales = exports.sundayAsFirstDayOfWeekLocales = ['es-AR', // Argentina
'en-BZ', // Belize
'en-BO', // Bolivia
'pt-BR', // Brazil
'en-CA', // Canada
'es-CL', // Chile
'zh-CN', // China
'es-CO', // Colombia
'es-CR', // Costa Rica
'es-DO', // Dominican Republic
'es-EC', // Ecuador
'es-SV', // El Salvador
'es-GT', // Guatemala
'es-HN', // Honduras
'zh-HK', // Hong Kong
'he_IL', // Israel
'en-JM', // Jamaica
'ja', // Japan
'ja-JP', // Japan
'', // Kenya
'', // Macao
'es-MX', // Mexico
'es-NI', // Nicaragua
'es-PA', // Panama
'es-PE', // Peru
'en-PH', // Philippines
'es-PR', // Puerto Rico
'en-za', // Southern Africa
'ko_KR', // South Korea
'zh-TW', // Taiwan
'en-US', // United States
'es-VE', // Venezuela
'en' // Zimbabwe
];

var saturdayAsFirstDayOfWeekLocales = exports.saturdayAsFirstDayOfWeekLocales = ['ps_AF', // Afghanistan
'ar_DZ', // Algeria
'ar-BH', // Bahrain
'ar-EG', // Egypt
'fa_IR', // Iran
'ar-IQ', // Iraq
'ar-JO', // Jordan
'ar-KW', // Kuwait,
'ar-LY', // Libya
'ar-OM', // Oman
'ar-QA', // Qatar
'ar-SA', // Saudi Arabia,
'ar-SY', // Syria,
'ar-AE', // United Arab Emirates
'ar-YE' // Yemen
];